import { useTranslations } from 'next-intl';
import { ButtonV2 } from 'components/shared/ButtonV2';
import { CustomImage } from 'components/shared/custom-image/CustomImage';
import styles from './EndBannerSection.module.css';

/** Photon LED-grid hero shot used as the closing product visual. */
const PRODUCT_IMAGE = 'web_v2/photon/landing-page/end-banner-product.png';

/**
 * Photon — closing tagline + CTA + full-width product image.
 * Layout mirrors Ring PRO's ClosingSection: centered text block at the
 * top (heading, supporting line, CTA), then a wide product shot flush
 * below that scales to the viewport width.
 */
const EndBannerSection = () => {
  const t = useTranslations('photon');

  return (
    <section className={styles.section}>
      <div className={styles.contentContainer}>
        <h2 className={styles.heading}>
          {t('photon.endBannerSection.heading.productName')}
        </h2>
        <p className={styles.description}>
          {t('photon.endBannerSection.text.tagline')}
        </p>
        <div className={styles.ctaWrapper}>
          <ButtonV2
            variant="blue"
            aria-label={t('photon.endBannerSection.ariaLabel.preBook')}
            href="/photon/buy"
          >
            {t('photon.endBannerSection.button.preOrder')}
          </ButtonV2>
        </div>
      </div>

      <div className={styles.imageWrapper}>
        <CustomImage
          className={styles.productImage}
          src={PRODUCT_IMAGE}
          alt={t('photon.endBannerSection.image.ledGrid')}
          fill
          sizes="(max-width: 1540px) 100vw, 1540px"
          priority={false}
        />
      </div>
    </section>
  );
};

export default EndBannerSection;
